import Vue from 'vue'
import Sidenav from './App.vue'
import Buefy from 'buefy'

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

if(document.getElementById("sideNavApp")){
    new Vue({
        render: h => h(
            Sidenav, {
                props:{
                    catalogueUrl:document.getElementById("sideNavApp")
                        .getAttribute("catalogue"),
                    inventoryUrl:document.getElementById("sideNavApp")
                        .getAttribute("inventory"),
                    isContent:document.getElementById("sideNavApp")
                        .getAttribute("is-content"),
                    isStore:document.getElementById("sideNavApp")
                        .getAttribute("is-store"),
                    company:document.getElementById("sideNavApp")
                        .getAttribute("company"),
                    profileEndpoint:document.getElementById("sideNavApp")
                        .getAttribute("profile"),
                    cmsBasic: document.getElementById("sideNavApp")
                        .getAttribute("cms-basic"),
                    cmsPanel:document.getElementById("sideNavApp")
                        .getAttribute("cms-panel"),
                    orderPanel:document.getElementById("sideNavApp")
                        .getAttribute("order-panel"),
                    inboxPanel: document.getElementById("sideNavApp")
                        .getAttribute("inbox-panel"),
                    isB2b: document.getElementById("sideNavApp")
                        .getAttribute("is-b2b"),
                    faqs: document.getElementById("sideNavApp")
                        .getAttribute("faqs"),
                    blog: document.getElementById("sideNavApp")
                        .getAttribute("blog"),
                    hasBlog: document.getElementById("sideNavApp")
                        .getAttribute("has-blog"),
                    customPagesUrl: document.getElementById("sideNavApp")
                        .getAttribute("custom-pages-url"),
                    isFullSite: document.getElementById("sideNavApp")
                        .getAttribute("is-full-site")
                }
            }
        )
    }).$mount('#sideNavApp')
}